import { memo, useCallback } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@flote/ui';
import { BankAccountForm, type BankAccountFormData } from '../../pages/checkout/components/BankAccountForm';
import { useModal } from '../../lib/modal';

interface BankAccountFormModalProps {
  onSubmit: (data: BankAccountFormData) => Promise<void>;
  isProcessing?: boolean;
}

export const BankAccountFormModal = memo<BankAccountFormModalProps>(
  ({ onSubmit, isProcessing = false }) => {
    const { closeModal } = useModal();

    const handleOpenChange = useCallback(
      (open: boolean) => {
        if (!open && !isProcessing) {
          closeModal();
        }
      },
      [closeModal, isProcessing]
    );

    return (
      <Dialog open onOpenChange={handleOpenChange}>
        <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Add Bank Account</DialogTitle>
            <DialogDescription>
              Enter your bank account details for ACH payment processing
            </DialogDescription>
          </DialogHeader>

          <BankAccountForm onSubmit={onSubmit} isProcessing={isProcessing} />
        </DialogContent>
      </Dialog>
    );
  }
);

BankAccountFormModal.displayName = 'BankAccountFormModal';
